export default "__VITE_ASSET__Bvhje6It__"